/**
* These must map to ids assigned by shell to workloads displayed in App Tiles section.
*/
export class KnownWorkloadReferralNames {
    public static Calendar = 'Calendar';
    public static Excel = 'ExcelOnline';
    public static Forms = 'OfficeForms';
    public static Mail = 'Mail';
    public static OneDrive = 'Documents';
    public static OneNote = 'OneNoteOnline';
    public static PowerPoint = 'PowerPointOnline';
    public static Project = 'Project';
    public static SharePoint = 'Sites';
    public static Skype = 'Skype';
    public static Sway = 'Sway';
    public static Visio = 'VisioOnline';
    public static Word = 'WordOnline';
    public static PowerBI = 'PowerBIv2';
}
